import { render } from "./SegmentGeographicalArea.vue?vue&type=template&id=155875b7&scoped=true"
import script from "./SegmentGeographicalArea.vue?vue&type=script&lang=ts"
export * from "./SegmentGeographicalArea.vue?vue&type=script&lang=ts"

import "./SegmentGeographicalArea.vue?vue&type=style&index=0&id=155875b7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-155875b7"

export default script